<template>
  <section v-if="bonExpedition">
    <header class="border-entete">
      <div class="level">
        <div class="level-left is-justify-content-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3"> {{ $t('detailBonExpedition.title') }} </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <dropdownButton
              class="mgr-2"
              type="is-addOrEdit"
              :permission="constantes.BON_EXPEDITION.maj"
              :actions="[]"
              @click="() => {
                $router.push({
                  name: 'm.logistique.bon_expedition',
                  params: { id: bonExpedition.id },
                });
              }">
              {{ $t('general.button.edit')}}
            </dropdownButton>
            <button
              class="button"
              @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown ref="dropdownEdition" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="chevron-down" class="has-text-secondary-icon"></b-icon>
                  </template>
                  <b-dropdown-item
                    class="has-text-left"
                    @click="checkPermissions(constantes.BON_EXPEDITION.editer)
                      ? edition(constantes.TYPE_PDF) : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="has-text-left"
                    @click="checkPermissions(constantes.BON_EXPEDITION.editer)
                      ? edition(constantes.TYPE_DOCX) : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.BON_EXPEDITION.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </header>
    <user-warning-message
      :users="[{
        id: bonExpedition.contactExpediteurId,
        msg: 'utilisateur.warning.contactExpediteurArchive'
      }]"/>
    <informations-generales :bonExpedition="bonExpedition"/>
    <information-ots :ordreTravails="ordreTravails" class="pdt-20px"/>
    <section class="card mgt-20px">
      <header class="header-card">
        <p> {{ $t('piecesJointes.attachments')}} </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes
          :checkPermissions="checkPermissions(constantes.BON_EXPEDITION.maj)"
          readOnly deletable autoSave/>
      </div>
    </section>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { get } from '@/api/logistique/bonExpedition';
import { getAll as getAllOtTechnique } from '@/api/logistique/ordreTravailTech';
import breadcrumb from '@/components/general/breadcrumb';
import PiecesJointes from '@/components/general/piecesJointes';
import dropdownButton from '@/components/general/button/dropdownButton';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import informationOts from '@/components/logistique/bonExpedition/detail/informationOts';
import informationsGenerales from '@/components/logistique/bonExpedition/detail/informationsGenerales';
import messageErreur from '@/services/general/messageErreur';
import { BON_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import { editionOts } from '@/services/logistique/ordreTravail/expedition/bonExpeditionService';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');

export default {
  data() {
    return {
      bonExpedition: null,
      constantes: {
        BON_EXPEDITION,
        TYPE_DOCX,
        TYPE_PDF,
      },
      ordreTravails: [],
    };
  },
  components: {
    breadcrumb,
    informationOts,
    dropdownButton,
    pieceJointeButton,
    userWarningMessage,
    informationsGenerales,
    appPiecesJointes: PiecesJointes,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailBonExpedition.breadcrumb.liste'), route: { name: 'l.logistique.bon_expedition' }, isActive: false },
        { title: this.$t('detailBonExpedition.breadcrumb.detail'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async getOrdreTravails() {
      const query = {
        bonExpeditionId: this.$route.params.id,
        societeId: this.societeActiveId,
        agencesId: this.agencesSelectionnees.map(a => a.agenceId),
      };
      this.ordreTravails = (await getAllOtTechnique({ query })).data.result.items;
    },
    async edition(extension) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await editionOts(this.bonExpedition.otImpressionsIds, extension);
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'BonExpedition' });
      await this.getOrdreTravails();
      this.bonExpedition = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.setInformationPage(this.$t('pageLogistique.ot.detailBonExpedition'));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};

</script>
